var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGovernanceEsg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7369_26383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 28C8 16.9543 16.9543 8 28 8C39.0457 8 48 16.9543 48 28C48 39.0457 39.0457 48 28 48C16.9543 48 8 39.0457 8 28Z",
    fill: "#D6E3F1"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7369_26383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2424 25.126C18.0628 24.7929 17.9796 24.4164 18.0021 24.0387C18.0247 23.661 18.152 23.297 18.3699 22.9876C18.7259 22.4652 19.2027 22.0364 19.7599 21.7376L26.0107 18.4843C26.6251 18.1648 27.3074 17.998 27.9999 17.998C28.6924 17.998 29.3746 18.1648 29.989 18.4843L36.239 21.7401C36.7962 22.0389 37.273 22.4677 37.629 22.9901C37.8469 23.2995 37.9742 23.6635 37.9968 24.0412C38.0193 24.4189 37.9361 24.7954 37.7565 25.1285C37.5632 25.4942 37.2733 25.7998 36.9183 26.0121C36.5633 26.2245 36.1568 26.3353 35.7432 26.3326H20.2565C19.8425 26.3352 19.4357 26.2241 19.0805 26.0113C18.7254 25.7985 18.4354 25.4923 18.2424 25.126ZM37.1665 36.3326C37.1665 35.8906 36.9909 35.4667 36.6784 35.1541C36.3658 34.8416 35.9419 34.666 35.4999 34.666V27.9993H33.8332V34.666H31.3332V27.9993H29.6665V34.666H26.3332V27.9993H24.6665V34.666H22.1665V27.9993H20.4999V34.666C20.0578 34.666 19.6339 34.8416 19.3214 35.1541C19.0088 35.4667 18.8332 35.8906 18.8332 36.3326C18.6122 36.3326 18.4002 36.4204 18.244 36.5767C18.0877 36.733 17.9999 36.945 17.9999 37.166C17.9999 37.387 18.0877 37.5989 18.244 37.7552C18.4002 37.9115 18.6122 37.9993 18.8332 37.9993H37.1665C37.3875 37.9993 37.5995 37.9115 37.7558 37.7552C37.9121 37.5989 37.9999 37.387 37.9999 37.166C37.9999 36.945 37.9121 36.733 37.7558 36.5767C37.5995 36.4204 37.3875 36.3326 37.1665 36.3326Z",
    fill: "#374151"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7369_26383",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.454902 0 0 0 0 0.72549 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7369_26383"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7369_26383",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7369_26383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernanceEsg);
export default __webpack_public_path__ + "static/media/governanceEsg.35e6d13be5a8b6eb05003c50380e6f8c.svg";
export { ForwardRef as ReactComponent };